import { defineComponent, h, useAttrs } from 'vue'
import { VListItemSubtitle, VListItemTitle } from 'vuetify/components'

function createListItemSectionCompat(name, Component, legacyClass) {
  if (Component) {
    Component.compatConfig = {
      ...(Component.compatConfig || {}),
      INSTANCE_ATTRS_CLASS_STYLE: false
    }
  }

  return defineComponent({
    name,
    compatConfig: {
      RENDER_FUNCTION: false,
      COMPONENT_V_MODEL: false,
      INSTANCE_ATTRS_CLASS_STYLE: false
    },
    inheritAttrs: false,

    setup(_, { slots }) {
      const attrs = useAttrs()
      const tag = Component || 'div'

      return () =>
        h(
          tag,
          {
            ...attrs,
            class: [legacyClass, attrs.class]
          },
          slots
        )
    }
  })
}

const VListItemActionCompat = createListItemSectionCompat(
  'VListItemActionCompat',
  undefined,
  'v-list-item__action'
)

const VListItemSubtitleCompat = createListItemSectionCompat(
  'VListItemSubtitleCompat',
  VListItemSubtitle,
  'v-list-item__subtitle'
)

const VListItemTitleCompat = createListItemSectionCompat(
  'VListItemTitleCompat',
  VListItemTitle,
  'v-list-item__title'
)

export { VListItemActionCompat, VListItemSubtitleCompat, VListItemTitleCompat }
